import settings from 'client/utils/settings';
import StackdriverErrorReporter from './stackdriver-errors-js';

const StackTrace = require('stacktrace-js');

// @ts-ignore
window.StackTrace = StackTrace; // needed for stackdriver

// TODO: remove once fixed in Firebase JS SDK
// see: https://github.com/firebase/firebase-js-sdk/issues/1642
// Firebase internal assertions are unrecoverable
window.onerror = (event, source, lineno, colno, error) => {
  if (error && error.message && error.message.match(/INTERNAL ASSERTION FAILED: AsyncQueue is already failed/)) {
    console.error('Firebase internal error caught. Reloading the page.');
    window.location.reload();
  }
};

const shouldBeReported = (error: Error | string) => {
  const message = typeof error === 'string' ? error : error.message || '';
  if (message.match(/Failed to register a ServiceWorker/) && window.navigator.userAgent.match(/bot/i)) {
    return false;
  }
  return true;
};

const getErrorHandler = () => {
  if (settings.stackdriver.enabled) {
    const stackdriverReporter = new StackdriverErrorReporter();
    stackdriverReporter.start({
      key: settings.stackdriver.apiKey,
      projectId: settings.stackdriver.projectId,
      // The macro below is replaced by webpack
      // @ts-ignore
      // eslint-disable-next-line no-undef
      version: __INTROWISE_VERSION__,
    });
    const report = (error: Error | string) => {
      if (shouldBeReported(error)) {
        stackdriverReporter.report(error);
      }
    };
    const setUser = (user: string) => stackdriverReporter.setUser(user);
    return {
      report,
      setUser,
    };
  }
  return {
    report: console.error,
    setUser: () => {},
  };
};

const errorHandler = getErrorHandler();

export default errorHandler;
